import axios from "axios";

let clientIp = null;

export const loadClientIp = async () => {
  if (clientIp) return clientIp;

  try {
    const { data } = await axios.get("https://api.ipify.org?format=json");
    clientIp = data.ip;
    return clientIp;
  } catch (error) {
    console.error(error);
    return null;
  }
};

export const getClientIp = () => clientIp;